// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jv-1";
export var messageSideRight = "_jv-2";
export var subscribeToBackInStockBubbleContainer = "_jv-0";